'use strict';

var React = require('react');

var DialogContent = React.createClass({
    displayName: 'DialogContent',


    propTypes: {
        className: React.PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            className: ''
        };
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: "dialog-content " + this.props.className },
            this.props.children
        );
    }

});

module.exports = DialogContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Dialog/DialogContent.js
// module id = 40
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30